import axios from "axios";
import Swal from "sweetalert2";
import { unauthorizedInterceptors } from "../utilities/functions";
const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/inventory`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const authAPI = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/auth`,
  headers: {
    "Content-Type": "application/json",
  },
});
unauthorizedInterceptors(API);
unauthorizedInterceptors(authAPI);

export default API;
